import React, { useState, useEffect, useRef } from 'react';
import RcbPopup from './RcbPopup';
import OTPSection from './OTPSection';
import './RequestCallBack.scss';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import DetectIcon from '../../../../assets/baas/tvs-detect.svg';
import EnquirySuccessPopup from './EnquirySuccessPopup';
import IQubeEnquirySuccessPopup from './iQubeEnquirySuccessPopup';

import {
  getQueryParam,
  getCookie,
  getGclidCookie,
  getGsessionIdCookie,
  getDeviceType,
} from './trackingUtils';

const RequestCallBack = (props) => {
  console.log('RequestCallBack Props:', props);
  const { isPopupOpen, onPopupClose } = props;
  const [pincode, setPincode] = useState('');
  const [city, setCity] = useState('');
  const [stateName, setStateName] = useState('');
  const [cityId, setCityId] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [mobile, setMobile] = useState('');

  const [locationFetched, setLocationFetched] = useState(false);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);

  const [otpEnabled, setOtpEnabled] = useState(false);
  const [sessionId, setSessionId] = useState(null);

  const [launchMessage, setLaunchMessage] = useState('');

  const [autoDetectTriggered, setAutoDetectTriggered] = useState(false);

  const dropdownRef = useRef(null);

  const [trackingData, setTrackingData] = useState({
    GCLID: '',
    GSessionID: '',
    CID: '',
    DeviceType: '',
  });
  const resetForm = () => {
    setPincode('');
    setCity('');
    setStateName('');
    setCityId('');
    setFullName('');
    setMobile('');
    setEmail('');
    setLocationFetched(false);
    setLaunchMessage('');
    setSuggestions([]);
    setShowDropdown(false);
    setOtpEnabled(false);
    setAutoDetectTriggered(false);
    setSessionId(null);
  };

  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const getScooterSlug = () => {
    if (!pathname) return 'evscooter';

    const parts = pathname.split('/');
    return parts[2] || 'evscooter';
  };

  const scooterSlug = getScooterSlug();

  const API_BASE = `/electric-scooters/${scooterSlug}/api/VehicleFeatures/ProductFeatures`;
  const SuccessPopupComponent = pathname.includes('orbiter-baas')
    ? EnquirySuccessPopup
    : pathname.includes('iqube-baas')
    ? IQubeEnquirySuccessPopup
    : null;
  useEffect(() => {
    if (showSuccessPopup) {
      const timer = setTimeout(() => {
        setShowSuccessPopup(false);
        onPopupClose();
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [showSuccessPopup, onPopupClose]);

  useEffect(() => {
    if (!isPopupOpen) {
      resetForm();
      setShowSuccessPopup(false);
    }
  }, [isPopupOpen]);

  /* ---------------- Debug Launch Message ---------------- */

  useEffect(() => {
    console.log('Launch Message Updated:', launchMessage);
  }, [launchMessage]);

  /* ---------------- Tracking ---------------- */

  useEffect(() => {
    const gclid = getQueryParam('gclid') || getGclidCookie();
    const gsessionid = getQueryParam('gsessionid') || getGsessionIdCookie();
    const cid = getCookie('_ga');
    const deviceType = getDeviceType();

    setTrackingData({
      GCLID: gclid,
      GSessionID: gsessionid,
      CID: cid,
      DeviceType: deviceType,
    });
  }, []);

  /* ---------------- Close dropdown outside click ---------------- */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  /* ---------------- AUTOCOMPLETE API ---------------- */

  const searchLocation = async (query) => {
    try {
      const res = await fetch(`${API_BASE}/GetProductFeatureAutoCompleteData`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query }),
      });
      const data = await res.json();

      if (data.success && data.response?.DataList) {
        setSuggestions(data.response.DataList);
        setShowDropdown(true);
      } else {
        setSuggestions([]);
        setShowDropdown(false);
      }
    } catch (error) {
      console.error('Autocomplete API error', error);
    }
  };

  /* ---------------- PINCODE INPUT ---------------- */

  const handlePincodeChange = (e) => {
    const value = e.target.value;

    setPincode(value);
    setCity('');
    setStateName('');
    setLocationFetched(false);
    setLaunchMessage('');

    if (value.length > 0) {
      searchLocation(value);
    } else {
      setSuggestions([]);
      setShowDropdown(false);
    }
  };

  /* ---------------- Auto Detect on First Click ---------------- */

  const handlePincodeFocus = () => {
    if (!autoDetectTriggered) {
      setAutoDetectTriggered(true);
      handleDetectLocation();
    }
  };

  /* ---------------- SELECT LOCATION ---------------- */

  const handleSelectLocation = async (item) => {
    setLaunchMessage('');

    try {
      const res = await fetch(`${API_BASE}/GetProductFeatureLocationDetails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ location: item.Geo }),
      });
      const data = await res.json();

      if (data.success && data.response) {
        const { Pincode, City, State } = data.response;

        setPincode(Pincode);
        setCity(City);
        setStateName(State);

        setSuggestions([]);
        setShowDropdown(false);

        await getCityDeliveryDetails(Pincode, City, State);

        setLocationFetched(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- Detect Location ---------------- */

  const handleDetectLocation = () => {
    if (!navigator.geolocation) {
      alert('Geolocation not supported');
      return;
    }

    setLoadingLocation(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;

        const location = `${lat},${long}`;

        getLocationDetails(location);
      },
      () => {
        alert('Location access denied');
        setLoadingLocation(false);
      },
      { enableHighAccuracy: true, timeout: 15000 }
    );
  };

  /* ---------------- LOCATION DETAILS API ---------------- */

  const getLocationDetails = async (location) => {
    try {
      const res = await fetch(`${API_BASE}/GetProductFeatureLocationDetails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ location }),
      });

      const data = await res.json();

      if (data.success && data.response?.Pincode) {
        const { Pincode, City, State } = data.response;

        setPincode(Pincode);
        setCity(City);
        setStateName(State);
        await getCityDeliveryDetails(Pincode, City, State);
        setShowDropdown(false);
        setLocationFetched(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingLocation(false);
    }
  };

  /* ---------------- CITY DELIVERY API ---------------- */

  const getCityDeliveryDetails = async (pincodeValue, cityNameValue, stateValue) => {
    try {
      const res = await fetch(`${API_BASE}/GetEnquiryCityDeliveryTimelineDetails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cityName: cityNameValue,
          pincode: pincodeValue,
          state: stateValue,
        }),
      });

      const data = await res.json();

      if (data?.success && data?.apiResponse) {
        setCityId(data.apiResponse.CityId || '');

        const bookingMessage = data?.apiResponse?.LocationSearchDetails?.BookingAmount?.[0] ?? '';

        setLaunchMessage(bookingMessage);
      }
    } catch (error) {
      console.error('City Delivery API Error:', error);
    }
  };

  /* ---------------- GENERATE OTP ---------------- */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;

    setLoadingOtp(true);

    const payload = {
      FullName: fullName,
      MobileNumber: mobile,
      Email: email,
      CityId: cityId,
      PinCode: pincode,
      EnquiryType: 'QuickEnquiry',
      L2Source: 'QuickEnquiry',
      DealerId: '',
      EnquiryId: '',
      IsUserConsentTaken: true,
      IsMarketingConsentTaken: true,
      DeviceType: trackingData.DeviceType,
      CID: trackingData.CID,
      GCLID: trackingData.GCLID,
      GSessionID: trackingData.GSessionID,
      EnquiryMediaSource: {},
    };

    try {
      const res = await fetch(`${API_BASE}/EnquiryGenerateOTP`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.success && data.apiResponse) {
        setSessionId(data.apiResponse.EnquiryId);
        setOtpEnabled(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingOtp(false);
    }
  };

  const isFormValid =
    locationFetched &&
    /^[A-Za-z]+(?: [A-Za-z]+)*$/.test(fullName.trim()) &&
    /^[0-9]{10}$/.test(mobile) &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isCityNotLaunched = launchMessage?.trim()?.length > 0;
  return (
    <>
      <RcbPopup
        isOpen={isPopupOpen && !showSuccessPopup}
        onClose={onPopupClose}
        className="requestcallback-popup"
      >
        <form className="callback-form" onSubmit={handleSubmit}>
          <div className="row no-gutters">
            <div className="modal-left-content">
              <img
                src={props?.fields?.['Form Image']?.value?.src || ''}
                alt={props?.fields?.['Form Image']?.value?.alt || 'Form Image'}
                className="img-fluid"
              />
            </div>

            <div className="modal-right-content">
              <h3 className="modal-title">{props?.fields?.['Form Heading']?.value || ''}</h3>

              <div className="modal-right-content-inner">
                <p>{props?.fields?.['OTP Form Description']?.value || ''}</p>
                <div className="location-group" ref={dropdownRef}>
                  <div className="d-flex">
                    <div className="form-group w-100" style={{ position: 'relative' }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={
                          loadingLocation
                            ? 'Pin Code*'
                            : props?.fields?.['Location Label']?.value ?? ''
                        }
                        value={city ? `${pincode}, ${city}` : pincode}
                        onChange={handlePincodeChange}
                        onFocus={handlePincodeFocus}
                        disabled={otpEnabled}
                        autoComplete="off"
                      />

                      {showDropdown && suggestions.length > 0 && (
                        <ul className="location-dropdown">
                          {suggestions.map((item, index) => (
                            <li key={item.Geo || index} onClick={() => handleSelectLocation(item)}>
                              {item.Name}
                            </li>
                          ))}
                        </ul>
                      )}
                      {isCityNotLaunched && (
                        <div className="location-info-details" id="notLaunchedMsg">
                          <RichText field={props?.fields?.['Not Launched Msg']} />
                        </div>
                      )}
                    </div>
                    <div className="location-position">
                      <button
                        type="button"
                        className="location"
                        onClick={handleDetectLocation}
                        disabled={loadingLocation || otpEnabled}
                      >
                        <img src={DetectIcon} alt="Detect Location" />
                        {loadingLocation ? 'Detect' : 'Detect'}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    value={fullName}
                    placeholder={props?.fields?.Name?.value || ''}
                    maxLength={50}
                    onKeyPress={(e) => {
                      if (!/[a-z ]/i.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^a-zA-Z ]/g, '');
                      setFullName(value);
                    }}
                    onPaste={(e) => e.preventDefault()}
                    disabled={!locationFetched || isCityNotLaunched || otpEnabled}
                  />
                </div>

                <div className="form-group">
                  <div className="d-flex">
                    <div className="country-field">+91</div>

                    <input
                      type="text"
                      className="form-control"
                      placeholder={props?.fields?.Mobile?.value || ''}
                      maxLength={10}
                      inputMode="numeric"
                      value={mobile}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setMobile(value);
                        }
                      }}
                      disabled={!locationFetched || isCityNotLaunched || otpEnabled}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder={props?.fields?.Email?.value || 'Email'}
                    value={email}
                    maxLength={100}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={!locationFetched || isCityNotLaunched || otpEnabled}
                  />
                </div>

                {!otpEnabled && (
                  <div className="button-wrapper text-center">
                    <button
                      className="btn primary-gradient-btn"
                      type="submit"
                      disabled={!isFormValid || loadingOtp || isCityNotLaunched}
                    >
                      {loadingOtp
                        ? 'Submit'
                        : props?.fields?.['Form Submit Button Text']?.value || ''}
                    </button>
                  </div>
                )}

                {otpEnabled && (
                  <OTPSection
                    enquiryId={sessionId}
                    mobileNumber={mobile}
                    fullName={fullName}
                    email={email}
                    cityId={cityId}
                    pincode={pincode}
                    trackingData={trackingData}
                    otpPlaceholder={props?.fields?.['OTP Field Label']?.value || ''}
                    resendText={props?.fields?.['Resend Button Text']?.value ?? 'Resend'}
                    finalSubmitText={
                      props?.fields?.['Final Submit CTA Text']?.value ?? 'Final Submit'
                    }
                    privacyConsent={props?.fields?.['Privacy Consent']}
                    marketingConsent={props?.fields?.['Marketing Consent']}
                    onVerified={() => {
                      setOtpEnabled(false);
                      setShowSuccessPopup(true);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </form>
      </RcbPopup>

      {SuccessPopupComponent && (
        <SuccessPopupComponent
          isOpen={showSuccessPopup}
          onClose={() => {
            setShowSuccessPopup(false);
            onPopupClose();
          }}
        />
      )}
    </>
  );
};
export default React.memo(RequestCallBack);
